<template>
    <a-button
        v-if="videoDuration"
        ghost
        class="button">
        {{ videoDuration }}
    </a-button>
    <div
        class="button"
        v-else>
        --
    </div>
</template>

<script>
 import Vue from 'vue';
 import Button from "ant-design-vue/lib/button";
 import EventBus from "../event/event-bus.js"

 import { formatSecond } from "../util/time.js"
 import { mapGetters } from 'vuex'

 Vue.component(Button.name, Button);

 export default {
     name: 'TimeArea',
     props: {
     },
     components: {
     },
     computed: {
         ...mapGetters([
             "videoCurrentTime",
             "videoDuration"
         ]),
     },
     created() {
         console.log("Create TimeArea")
     },
     mounted() {
         console.log("Mount TimeArea")

         EventBus.$on("playerProgress", (duration, current) => {
             this.$store.commit("updateVideoCurrentTime", formatSecond(current))
             this.$store.commit("updateVideoDuration", formatSecond(duration))
         })
     },
     beforeDestroy() {
         EventBus.$off("playerProgress");
     },
     methods: {
     }
 }
</script>

<style scoped>
 .button {
     color: #AAA;
     border: none;
     margin-right: 10px;
     width: 80px;
     text-align: center;
 }
</style>
